import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "src/store";

export interface IpopupPromotions {
  popupPromotionsFilter: {
    country: string;
    platform: string;
  };
}

const initialState: IpopupPromotions = {
  popupPromotionsFilter: {
    country: "HK",
    platform: "M21",
  },
};

type popupPromotionsFilter = {
  country?: string;
  platform?: string;
};

export const popupPromotionsFilterSlice = createSlice({
  name: "thisPopupPromotionsFilter",
  initialState,
  reducers: {
    setPopupPromotionsFilter: (
      state,
      action: PayloadAction<popupPromotionsFilter>
    ) => {
      state.popupPromotionsFilter = {
        ...state.popupPromotionsFilter,
        ...action.payload,
      };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const { setPopupPromotionsFilter } =
  popupPromotionsFilterSlice.actions;

export const getPopupPromotionsFilter = (state: RootState) =>
  state.thisPopupPromotionsFilter.popupPromotionsFilter;

export default popupPromotionsFilterSlice.reducer;
